// extracted by mini-css-extract-plugin
module.exports = {"maindiv":"OfferTnC_maindiv__3k5J2","markdown_div":"OfferTnC_markdown_div__3dtTf","loadingdiv":"OfferTnC_loadingdiv__3mBg_"};